// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Wotx","rootCenter":"LoadMoreObserver_rootCenter__3nPPa","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3WuBZ"};